/* Ctrl+P — size chart dialog.
 *
 * Plain dialog rather than <dialog>: this theme still has to work in older
 * mobile Safari, where showModal() is unavailable.
 *
 * Scroll lock uses position:fixed on <body> because iOS Safari ignores
 * overflow:hidden there; the scroll offset is saved and restored on close.
 */
(function () {
  'use strict';

  var scrollY = 0;

  function lock() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.width = '100%';
  }

  function unlock() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function open(dialog, trigger) {
    dialog.hidden = false;
    lock();
    dialog._opener = trigger || null;
    var closeBtn = dialog.querySelector('[data-cp-sc-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close(dialog) {
    if (dialog.hidden) return;
    dialog.hidden = true;
    unlock();
    if (dialog._opener && dialog._opener.focus) dialog._opener.focus();
  }

  function closeAny() {
    var open = document.querySelectorAll('[data-cp-sc-dialog]:not([hidden])');
    Array.prototype.forEach.call(open, close);
  }

  // Delegated so it survives section re-renders in the theme editor and any
  // AJAX that swaps the product form.
  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-cp-sc-open]') : null;
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-cp-sc-open'));
      if (dialog) {
        e.preventDefault();
        open(dialog, opener);
      }
      return;
    }

    if (e.target.closest && e.target.closest('[data-cp-sc-close]')) {
      var d = e.target.closest('[data-cp-sc-dialog]');
      if (d) close(d);
      return;
    }

    // Click on the backdrop itself (not the panel) closes.
    if (e.target.hasAttribute && e.target.hasAttribute('data-cp-sc-dialog')) {
      close(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAny();
  });
})();
